import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: ['eventId'],
  data: function data() {
    var validateDuration = function validateDuration(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入比赛时长'));
      } // 匹配 分:秒.百毫秒 格式


      var reg = /^\d+:[0-5]\d\.\d{2}$/;

      if (!reg.test(value)) {
        return callback(new Error('格式不正确，请输入 x:xx.xx 格式'));
      }

      callback();
    };

    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        reward_name: '',
        final_score: '',
        final_duration: '',
        student_id: '',
        final_format_time: ''
      },
      studentList: [],
      rules: {
        reward_name: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        final_score: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }],
        final_duration: [{
          required: true,
          message: "请填写",
          trigger: "change"
        }, {
          validator: validateDuration,
          trigger: 'blur'
        }],
        student_id: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, reward_name, final_score, final_duration, student_id, final_format_time;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getStudentList();

                console.log("data==", data);

                if (data) {
                  id = data.id, reward_name = data.reward_name, final_score = data.final_score, final_duration = data.final_duration, student_id = data.student_id, final_format_time = data.final_format_time;
                  _this.formData = {
                    id: id,
                    reward_name: reward_name,
                    final_score: final_score,
                    final_duration: final_duration,
                    student_id: student_id,
                    final_format_time: final_format_time
                  };

                  if (_this.formData.final_format_time != '0') {
                    _this.formData.final_duration = _this.formData.final_duration;
                  }
                } else {
                  _this.formData.id = '';
                }

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    getStudentList: function getStudentList() {
      var _this2 = this;

      this.$api.eventParticipantList({
        page_size: -1,
        event_id: this.eventId
      }).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.student_name = item.student.name;
            item.id_card = item.student.id_card;
          });
          _this2.studentList = data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this3.formData));

                    if (data.final_duration) {
                      var newDuration = data.final_duration;
                      data.final_format_time = newDuration;
                      data.final_duration = _this3.$utils.parseDuration(newDuration);
                    }

                    var reqFn = data.id ? 'eventAwardUpdate' : 'eventAwardAdd';

                    _this3.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                      event_id: _this3.eventId
                    })).then(function (res) {
                      if (res.code == 200) {
                        _this3.$message.success(_this3.formData.id ? '修改成功' : '添加成功');

                        _this3.$emit('change');

                        _this3.dialogFormVisible = false;
                      } else {
                        _this3.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};